import styled from "styled-components";

export const SessionExpiredModalStyled = styled.div`
  .gritter-notification {
    border-top: 1px solid rgba(241, 201, 17, 0.5);
    border-bottom: 1px solid rgba(241, 201, 17, 0.5);
  }

  .timer {
    font-weight: 600;
    padding-left: 3px;
    padding-right: 3px;
  }
`;
